export default {
    index:{
        'Brand Pavilion':'Brand Pavilion',
        "Merchant settlement":"Merchant settlement",
        "APP download":'APP download',
        "WeChat Mall":'WeChat Mall',
        "Locating":'Locating',
        "Sign in":'Sign in',
        "sign out":'sign out',
        "register":'register',
        "My Order":'My Order',
        "my collection":'my collection',
        "customer service":'customer service',
        "help center":'help center',
        "site navigation":'site navigation',
        "User Center":"User Center",
        "Home page":'Home page',
        "payment center":'payment center',
        "There is no product in the shopping cart, buy it now!":'There is no product in the shopping cart, buy it now!',
        "Go to the shopping cart to checkout":"Go to the shopping cart to checkout",
        "shopping cart":'shopping cart',
        "All Categories":'All Categories',
        "No related classification data":'No related classification data',
        "wholesale market":'wholesale market',
        "Merchant shop":'Merchant shop',
        "the whole country":'the whole country',
        "Shopping cart query failed, please try again later!":'Shopping cart query failed, please try again later!',
        "Loading failed, please try again later!":"Loading failed, please try again later!",
        "Latest Announcement":'Latest Announcement',
        "More":'More',
        "go and see":'go and see',
        "Template 1105_Title":'Template 1105_Title',
        "Template 1111_Title":'Template 1111_Title',
        "advertise":'advertise',
        "Template 1110_Title":"Template 1110_Title",
        "Template 1110_right mark 1":'Template 1110_right mark 1',
        "Template 1110_right mark 2":'emplate 1110_right mark 2',
        "Please enter a department name":'Please enter a department name',
        "Please enter the department code":'Please enter the department code',
        "Carousel failed to load, please try again later!":"Carousel failed to load, please try again later!",
        "Failed to get address, please try again later":'Failed to get address, please try again later',
        "Query failed, please try again later!":'Query failed, please try again later!',
        "Failed to get list of articles, please try again later!":"Failed to get list of articles, please try again later!"
    },
    login:{
        "account":'account',
        "password":'password',
        "retrieve password":'retrieve password',
        "Sign up now":'Sign up now',
        "please enter account":'please enter account',
        "please enter password":'please enter password',
        "Query failed, please try again later!":'Query failed, please try again later!',
        "login successful":'login successful',
        "Login failed, please try again later!":'Login failed, please try again later!',
        "Phone number":"Phone number",
        "verification code":'verification code',
        "Enter SMS verification code":'Enter SMS verification code',
        "Seconds to reacquire":"Seconds to reacquire",
        "Click to sign up to agree":"Click to sign up to agree",
        "User Agreement":"User Agreement",
        "Trouble logging in":"Trouble logging in",
        "obtain SMS verification code":"obtain SMS verification code",
        "I have registered, log in now":"I have registered, log in now",
        "please enter verification code":"please enter verification code",
        "Verification code verification":"Verification code verification",
        "Enter SMS verification code":"Enter SMS verification code",
        "Can not be empty":'Can not be empty',
        "The password length is 6~16 characters, including at least two types of numbers, letters and symbols":'The password length is 6~16 characters, including at least two types of numbers, letters and symbols',
        "The two passwords do not match":"两次密码不一致",
        "Click to refresh the verification code":'Click to refresh the verification code',
        "Please enter phone number":"Please enter phone number",
        "Sent successfully":"Sent successfully",
        "Failed to send SMS verification code, please try again later!":"Failed to send SMS verification code, please try again later!",
        "registration success":"registration success",
        "registration failed, please try again later!":'registration failed, please try again later!',
        "Failed to fetch list, please try again later!":"Failed to fetch list, please try again later!"
    },
    car:{
        "user":'user',
        "grade":'grade',
        "shopping cart":'shopping cart',
        "i have seen":"i have seen",
        "my favorites":'my favorites',
        "back to the top":'back to the top',
        "Items":'Items',
        "total":'total',
        "Go to the shopping cart to checkout":'Go to the shopping cart to checkout',
        "Yuan":'Yuan',
        "There is nothing in your shopping cart":"There is nothing in your shopping cart",
        "go see it again":'go see it again',
        "my footprint":"my footprint",
        "No history of your browsing":"No history of your browsing",
        "please sign in!":'please sign in!',
        "My track lookup failed, please try again later!":"My track lookup failed, please try again later!",
    },
    goods:{
        "all":'all',
        "Classification":"Classification",
        "brand":'brand',
        "sell like hot cakes":"sell like hot cakes",
        "price":'price',
        "newest":'newest',
        "Negotiable":'Negotiable',
        "add to Shopping Cart":'add to cart',
        "check the details":'check the details',
        "Sorry, there are no products under the corresponding product category or filter combination!":'Sorry, there are no products under the corresponding product category or filter combination!',
        "Has been successfully added to the shopping cart!":'Has been successfully added to the shopping cart!',
        "continue shopping":'continue shopping',
        "Go to the shopping cart to checkout":"Go to the shopping cart to checkout",
        "login required":"login required",
        "Sure":"Sure",
        "Index":'Index',
        "hot sale item":"hot sale item",
        "Failed to query product category, please try again later!":"Failed to query product category, please try again later!",
        "Failed to query the product list, please try again later!":"Failed to query the product list, please try again later!",
        "Shopping cart query failed, please try again later!":"Shopping cart query failed, please try again later!",
        "Failed to add cart, please try again later!":"Failed to add cart, please try again later!",
        "Temporarily out of stock":"Temporarily out of stock"
    }
}


// WEBPACK FOOTER //
// ./src/lang/en.js